import { createContext, useReducer } from "react";
import { useNavigate } from "react-router-dom";
import {KEYS_QUERYS, TYPE_THEME, TYPES_ALERTS,} from "../Constants/Const";
import {TransitionAlerts} from "./AlertComonent";

export const AuthContext = createContext();

const TYPE_AUTH = {
      login: 'logIn',
      logout: 'logOut',
      theme: 'theme',
      addReport: 'addReport',
}


const INITIAL_STATE = {
      logged: false,
      theme: {
            MUI: 'light',
            HIGH: '',
            AG: ''
      }
}

const contextInit =()=>{
      let user = JSON.parse( localStorage.getItem(KEYS_QUERYS.user) );
      if(!localStorage.getItem(TYPE_THEME.mode)){
            localStorage.setItem(TYPE_THEME.mode, TYPE_THEME.light);
      }
      let typeTheme = localStorage.getItem(TYPE_THEME.mode);

      return {
            logged: !!user,
            dataUser: !!user? user:null,
            theme: {
                  MUI: typeTheme,
                  HIGH: '',
                  AG: ''
            }
      }

      
}

const loginUser = (state, action) =>{
      switch (action.type) {

            case TYPE_AUTH.login:

                  return {
                        logged: true,
                        dataUser: action.payload,
                        theme: state.theme,
                  };

            case TYPE_AUTH.logout:                  
                  return {
                        ...INITIAL_STATE,
                        theme: state.theme
                  };
            case TYPE_AUTH.theme:
                  return {
                        ...state,
                        theme:{
                              MUI: action.statusTheme? "dark":"light",
                        }
                  }
            case TYPE_AUTH.addReport:
                  return {
                       ...state,
                         report: action.dataReport,
                  }
            default:
                  return state;
      }
}

export function AuthComponent({children}){

      const navigate = useNavigate();

      const [logUser, setLogUser] = useReducer(loginUser, INITIAL_STATE, contextInit );

      const onLoginUser = (dataUser) =>{

            const action ={
                  type: TYPE_AUTH.login,
                  payload: dataUser,
                  theme: logUser.theme,
            }
            
            localStorage.setItem(KEYS_QUERYS.user, JSON.stringify(dataUser));
            setLogUser(action);
            navigate("/Pre-Orden")
      }

      const addReport = (dataReport) => {
            const action = {
                  type: TYPE_AUTH.addReport,
                  dataReport: dataReport
            };
            setLogUser(action);
      }


      const logoutUser = async () => {
            localStorage.removeItem(KEYS_QUERYS.user)
            const action = {
                  type: TYPE_AUTH.logout,
            };
            setLogUser(action);
            navigate("/Login");
            TransitionAlerts({
                  open:true,
                  message: "Adios",
                  typeAlert: TYPES_ALERTS.info
            })
      }

      const changeTheme = (isLigth) =>{
            let type_theme = isLigth ? TYPE_THEME.dark : TYPE_THEME.light;
            localStorage.setItem(TYPE_THEME.mode, type_theme)
            const action = {
                  type: TYPE_AUTH.theme,
                  statusTheme: isLigth
            };
            setLogUser(action)
      }

      return(
            <AuthContext.Provider value={{
                  ...logUser,
                  log: onLoginUser,
                  exit: logoutUser,
                  changeTheme: changeTheme,
                  addReport: addReport
            }}>
                  {children}
            </AuthContext.Provider>
      );
}